import { Dialog, DialogActions, DialogContent, DialogTitle, Grid2 } from "@mui/material";
import { ExtincionDto } from "../models/extincionDto";
import * as Yup from "yup";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import MButton from '../../../components/inputs/yup/materialui/mButton';
import InputFecha from '../../../components/inputs/yup/materialui/inputFecha';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import ConfirmationModal from "../../../components/ui/materialui/confirmationModal";

interface IProps {
    show: boolean;
    onClose: () => void;
    onSubmit: (f: ExtincionDto) => void;
}

export const ModalExtincion = ({show, onClose, onSubmit} : IProps) => {

    const schemaRecaudacionForm = Yup.object<ExtincionDto>().shape({
        fechaRecaudacion: Yup.date().required("Fecha de recaudación requerida"),
        fechaExtincion: Yup.date().required("Fecha de extinción requerida"),
    });

    const {
        formState: { errors, isValid },
        handleSubmit,
        control,
        watch,
        reset,
        trigger
    } = useForm<ExtincionDto>({
        mode: "onTouched",
        resolver: yupResolver(schemaRecaudacionForm)
    });

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    })

    const dataForm = watch();

    const handleClose = () => {
        onClose();
        reset();
    }

    const preSubmit = (e: ExtincionDto) => {
        setModalConfirmacion({
            show: true,
            title: 'Extinguir mutuo',
            message: 'Una vez realizada la extinción del mutuo no se puede volver atrás. ¿Está seguro de continuar?',
            metodo: () => {
                onSubmit(e);
                reset();
            }
        });    
    }

    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({ ...modalConfirmacion, show: false })
                }
                onConfirm={modalConfirmacion.metodo}
                title={modalConfirmacion.title}
                show={modalConfirmacion.show}
                message={modalConfirmacion.message}
            />
            <Dialog open={show} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Extinguir Mutuo</DialogTitle>
                <DialogContent>
                    <Grid2 container spacing={3} sx={{ mt: 2 }}>
                        <Grid2 size={{xs:12}}>   
                            <InputFecha 
                                label="Fecha recaudación" 
                                name="fechaRecaudacion" 
                                fecha={dataForm.fechaRecaudacion} 
                                control={control} 
                                error={errors.fechaRecaudacion} 
                            />
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={2} sx={{ mt: 2 }}>
                        <Grid2 size={{xs:12}}>   
                            <InputFecha 
                                label="Fecha extinción" 
                                name="fechaExtincion" 
                                fecha={dataForm.fechaExtincion} 
                                control={control} 
                                error={errors.fechaExtincion} 
                            />
                        </Grid2>
                    </Grid2>
                </DialogContent>
                <DialogActions>
                    <MButton
                    variant="contained"
                    color="primary"
                    disabled={!isValid}
                    onClick={handleSubmit(preSubmit)}
                    startIcon={<CheckCircleTwoToneIcon />}
                    >
                    Guardar
                    </MButton>
                    <MButton
                    variant="contained"
                    color="inherit"
                    onClick={handleClose}
                    startIcon={<CloseIcon />}
                    >
                    Cancelar
                    </MButton>
                </DialogActions>
            </Dialog>
        </> 
    );       
}